var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#0364FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1164 21.3613C22.3958 21.3613 21.001 22.7561 21.001 24.4767V28.1059C21.001 29.8265 22.3958 31.2213 24.1164 31.2213H29.6284V51.5234C29.6284 53.244 31.0232 54.6388 32.7438 54.6388H36.373C38.0935 54.6388 39.4884 53.244 39.4884 51.5234V28.1323C39.4884 28.1235 39.4885 28.1147 39.4885 28.1059V24.4767C39.4885 22.7561 38.0937 21.3613 36.3731 21.3613H32.7438H24.1164Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8851 31.2213C49.6078 31.2213 51.8151 29.0141 51.8151 26.2913C51.8151 23.5686 49.6078 21.3613 46.8851 21.3613C44.1623 21.3613 41.9551 23.5686 41.9551 26.2913C41.9551 29.0141 44.1623 31.2213 46.8851 31.2213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorusIcon);
export default __webpack_public_path__ + "static/media/torus-icon.964e455fe2dfb40de233d11cbb6128df.svg";
export { ForwardRef as ReactComponent };